// A ilustração do chef da tela de entrada do PlugChef Desktop
// (plugchef.desktop/src/renderer/src/components/ChefIllustration.tsx), copiada como está: o login do
// portal tem a cara do login do Desktop, e o mesmo desenho nos dois lugares é o ponto. As cores são
// fixas de propósito (são as do desenho, não do tema), como lá. Mudança no desenho nasce lá e é
// copiada para cá.
export function IlustracaoChef(): JSX.Element {
  return (
    // Decorativa: o leitor de tela não tem nada a ganhar com ela.
    <svg width="360" height="440" viewBox="0 0 360 440" fill="none" className="h-auto max-w-full" aria-hidden="true">
      <ellipse cx="180" cy="230" rx="150" ry="150" fill="#eef2f7" />

      <ellipse cx="180" cy="400" rx="115" ry="14" fill="#dbe4ee" />

      <path d="M78 300v-70a102 102 0 0 1 204 0v70z" fill="#1f8fd6" />
      <path d="M78 300v-70a102 102 0 0 1 40-81 118 118 0 0 0-58 101v50z" fill="#1c7fbf" />
      <rect x="72" y="292" width="216" height="18" rx="9" fill="#0f2f45" />

      <rect x="150" y="120" width="60" height="90" rx="18" fill="#f2c9a0" />

      <circle cx="180" cy="110" r="46" fill="#f2c9a0" />
      <path
        d="M138 108c0-30 20-52 42-52s42 22 42 52c0-8-6-14-14-14-4-10-14-16-28-16s-24 6-28 16c-8 0-14 6-14 14z"
        fill="#141b26"
      />
      <path d="M138 108h84v6a4 4 0 0 1-4 4h-76a4 4 0 0 1-4-4z" fill="#141b26" />

      <circle cx="163" cy="112" r="4" fill="#1f2937" />
      <circle cx="199" cy="112" r="4" fill="#1f2937" />
      <path d="M166 128c6 6 20 6 26 0" stroke="#8a5a3a" strokeWidth="3" strokeLinecap="round" />

      <path
        d="M150 58c0-22 14-38 30-38s30 16 30 38c8-2 14 6 12 14-4 12-16 16-24 12a44 44 0 0 1-36 0c-8 4-20 0-24-12-2-8 4-16 12-14z"
        fill="#fff"
      />
      <rect x="146" y="66" width="68" height="14" rx="7" fill="#fff" />

      <path d="M96 240c-30 10-42 34-38 56 16-8 32-10 48-4z" fill="#1f8fd6" />
      <path d="M96 240c10-16 26-22 40-18l-14 40c-10 6-20 6-30-2z" fill="#f2c9a0" />

      <g transform="translate(60,268) rotate(-14)">
        <ellipse cx="30" cy="10" rx="34" ry="10" fill="#141b26" />
        <ellipse cx="30" cy="6" rx="30" ry="7" fill="#2a3342" />
      </g>

      <circle cx="70" cy="228" r="10" fill="#f59e0b" />
      <circle cx="94" cy="212" r="8" fill="#22c55e" />
      <circle cx="112" cy="230" r="7" fill="#ef4444" />
      <path d="M78 220c6-14 20-22 30-18" stroke="#8b95a6" strokeWidth="2" strokeLinecap="round" strokeDasharray="1 7" />

      <circle cx="252" cy="130" r="26" fill="#fff" />
      <path d="M240 130l8 8 14-16" stroke="#1f8fd6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />

      <path d="M280 190a6 6 0 1 0 0.01 0" fill="#1f8fd6" opacity="0.4" />
      <circle cx="286" cy="196" r="4" fill="#1f8fd6" opacity="0.5" />
      <circle cx="298" cy="176" r="3" fill="#f59e0b" opacity="0.6" />
      <circle cx="66" cy="150" r="3" fill="#1f8fd6" opacity="0.5" />
    </svg>
  );
}
